import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import LogoMark from "../components/LogoMark";

export default function NotFoundPage() {
    return (
        <div className="min-h-screen bg-[#0B1220] flex flex-col">
            <Header />
            <div className="flex-1 flex items-center justify-center px-4">
                <div className="text-center max-w-md" data-testid="not-found-page">
                    <div className="flex justify-center mb-8">
                        <LogoMark size="lg" dataTestId="not-found-logo" />
                    </div>
                    <div className="text-[#56CCF2] text-xs uppercase tracking-[0.25em] mb-4">404 · Off the trail</div>
                    <h1 className="text-4xl sm:text-5xl font-bold text-white tracking-tight mb-4">This path goes nowhere.</h1>
                    <p className="text-[#94A3B8] mb-10 leading-relaxed">
                        The investigation you were following may have moved — or never existed. Step back into the archive and pick another thread.
                    </p>
                    <Link
                        to="/"
                        data-testid="not-found-back-library"
                        className="inline-flex items-center px-6 py-2.5 rounded-full bg-[#56CCF2] text-[#0A0F1A] text-sm font-semibold hover:bg-white transition-colors"
                    >
                        Back to the library
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    );
}
